import axios from "axios";

export async function getPromotions() {
    const cmsUrl = localStorage?.getItem("cmsUrl")
    const lang = localStorage?.getItem("language")
    const headers = {
        "Authorization": "6623bad3-9f9f-4a3d-bc74-3aee997f033a",
    };

    return await axios({
        url: "https://cms." + cmsUrl + `/api/sections/getSectionCategory?section=promotion&category=WEB_Tradersroom&lang=${lang}`,
        // url: "https://cmsapi." + cmsUrl + `/api/section/getSectionPosting?name=promotion&lang=${lang}`,
        method: "get",
        headers: headers
    })
        .then((response) => {
            return response?.data;
        })
        .catch((e) => {
            console.error(e)
            throw e;
        });
}